import type { DocMigration } from "../docMigration";
import { deleteOrphanedEntitiesForDocEntityBase, migrateModelFromStaticRoomLayoutToDoc } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_78: DocMigration = {
  maxSchemaVersion: "0.0.78",

  description: "Refactor props to extend DocEntityBase and be on top-level document",
  apply(json: any) {
    migrateModelFromStaticRoomLayoutToDoc(json, "props", "PROP");

    const roomIds = Object.keys(json.rooms);

    if (!roomIds.length) {
      return json;
    }

    deleteOrphanedEntitiesForDocEntityBase(json, "props", roomIds);

    return json;
  },
};

export default migration_0_0_78;
